function isUnitEmpty( unit ) { return unit == "-" ? true : false }

export { isUnitEmpty };